import styled from 'styled-components';

export const Item = styled.li`
  color: gray;
  display: flex;
  justify-content: space-between;
  width: 360px;
`;

export const Text = styled.p`
  margin: 0;
  padding: 0;
`;

// const css = {
//   Item,
//   Text,
// };

// export default css;
